import ClubsAPI from '@/app/apis/main/club/club-api';

export default {
	/**
	* @return {object} admin tab reported table list
	* @param {*} reportedDetails
	* @param {*} breedId
	**/
	async getAdminReported(breedId, reportedDetails) {
		return ClubsAPI.getAdminReported(breedId, reportedDetails);
	},

	/**
	* @param {*} reportedDetails // report details
	**/
	async report(reportDetails) {
		return ClubsAPI.report(reportDetails);
	},

	/**
	* @param {Number} breedId
	* @param {Number} reportId
	* @param {String} type - Can be approve or disapprove
	**/
	async putActionReportedContent(groupId, reqBody) {
		return ClubsAPI.putActionReportedContent(groupId, reqBody);
	},

	async socialCreateGroup(reqBody) {
		return ClubsAPI.clubCreateGroup(reqBody);
	},

	/**
	 * @return {object} - group list
	**/
	async getGroups(groupDetails) {
		return ClubsAPI.getGroups(groupDetails);
	},

	/**
	* @param {Number} groupId
	* @param {Object} memberDetails
	**/
	async getGroupMembers(groupId,memberDetails) {
		return ClubsAPI.getGroupMembers(groupId, memberDetails);
	},

	/**
	* @param {Number} groupId
	* @param {Array} membersId
	**/
	async addMemberToGroup(groupId, reqBody) {
		return ClubsAPI.addMemberToGroup(groupId, reqBody);
	},

	/**
	* @param {Number} groupId
	**/
	async requestToJoinInGroup(groupId) {
		return ClubsAPI.requestToJoinInGroup(groupId);
	},

	/**
	* @param {Number} groupId
	* @param {Array} customerIds
	**/
	async updateGroupMemberStatus(groupId, reqBody) {
		return ClubsAPI.updateGroupMemberStatus(groupId, reqBody);
	},

	/**
	* @param {Number} groupId
	* @param {Array} customerIds
	**/
	async updateGroupMemberAccess(groupId, reqBody) {
		return ClubsAPI.updateGroupMemberAccess(groupId, reqBody);
	},

	/**
	* @param {Object} requesBbody
	**/
	async getAllGroupMembers(reqBody) {
		return ClubsAPI.getAllGroupMembers(reqBody);
	},

	async getGroupAdminRequest() {
		return ClubsAPI.getGroupAdminRequest();
	}
}